import { render, staticRenderFns } from "./WeekTreatment.vue?vue&type=template&id=6bf2947c&scoped=true"
import script from "./WeekTreatment.vue?vue&type=script&lang=js"
export * from "./WeekTreatment.vue?vue&type=script&lang=js"
import style0 from "./WeekTreatment.vue?vue&type=style&index=0&id=6bf2947c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2947c",
  null
  
)

export default component.exports